export const formatNum = (number: string) => {
    return new Intl.NumberFormat('nl-NL', {style: 'currency', currency: 'EUR'}).format(
        parseFloat(number),
    );
}